import { Box } from "@mui/material";
import { ParagraphText, UBButton } from "../../../Libraries";
import styles from "./styles.module.css";

/**
 * Amount column with optional inline action (Collect / Send money) + truncated amount text.
 * Used in invoice-style list rows (Quick Sale, Expense, etc.).
 */
const ListTableAmountCell = ({
  showAction = false,
  actionLoading = false,
  actionDisabled = false,
  onActionClick,
  buttonClassName = "",
  buttonTitle = "",
  buttonTitleStyle,
  amountWrapperClassName = "",
  children,
}) => {
  return (
    <ParagraphText className="amountColumnInnerWrapper fontSize14 fontWeight400 textRight">
      {showAction ? (
        <UBButton
          id="list_table_amount_btn"
          disabled={actionDisabled}
          onClick={(e) => {
            e.stopPropagation();
            onActionClick?.(e);
          }}
          className={`${styles.inlineActionButton} ${buttonClassName}`.trim()}
          loading={actionLoading}
          title={buttonTitle}
          titleStyle={buttonTitleStyle}
        />
      ) : null}
      <Box
        className={`amountColumnRightWrapper ${amountWrapperClassName}`.trim()}
      >
        <span className="truncate">{children}</span>
      </Box>
    </ParagraphText>
  );
};

export default ListTableAmountCell;
